<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Bonus Talep Detayları</h1>
          </div>

          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <router-link tag="li" to="/bonus-requests" class="breadcrumb-item"><a>Bonus Talepleri</a></router-link>
              <li class="breadcrumb-item active">Bonus Talep Detayları</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Bonus Talep Detayları

                <!--<button
                  class="btn btn-outline-primary btn-sm float-right"
                  @click="resetPage"
                  style="margin-right: 10px"
                >
                  <i class="fas fa-sync-alt"> </i> Sayfayı Yenile
                </button>-->
              </div>
              <div class="card-body table-responsive p-0" style="height: 650px">
                <table class="table table-striped projects">
                  <thead>

                    <tr>
                      <th style="width: 1%">#</th>
                      <th>İşlem Zamanı</th>
                      <th>Açıklama</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="datas.length == 0">
                      <td colspan="4" class="total-text text-center">
                        <b>Talep İşlem Sırasında</b>
                      </td>
                    </tr>
                    <tr v-for="(item, index) in datas" :key="index" :class="{ 'bg-danger': item.is_error }">
                      <td>#</td>
                      <td>
                        {{ item.date | DateFormat }}

                      </td>
                      <td>{{ item.context }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer"></div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>


export default {
  data() {
    return {
      id: this.$route.params.id,
      datas: [],

    };
  },

  methods: {


    getDatas() {
      this.$http
        .get("Bonus/ListBonusLog/" + this.$route.params.id)
        .then((response) => {
          if (response.data.length == 0) {
            this.$http.post("https://applogs.gorselpanel.com/api/list", {
              "request_row_count": 999,
              "site_name": this.$store.getters.getSite,
              "bonus": this.$route.params.id
            })
              .then((response) => {
                this.datas = response.body.data;
              });
          }
          else
            this.datas = response.data;
          this.overlay = false;
        });
    },


  },
  filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },

  created() {
    this.getDatas();


  },


};
</script>


// WEBPACK FOOTER //
// src/components/Bonus/BonusRequestDetail.vue